import { CartLinesUpdateEvent } from '@shopify/events';

/** Handles the "add another pair" offer inside the cart drawer. */
document.addEventListener('click', async (event) => {
  const button = /** @type {HTMLButtonElement | null} */ (
    event.target instanceof Element ? event.target.closest('[data-fz-nudge]') : null
  );
  if (!button) return;

  button.disabled = true;
  const id = Number(button.dataset.fzNudge);
  const routes = typeof Theme !== 'undefined' ? Theme.routes : { cart_add_url: '/cart/add.js', cart_url: '/cart' };
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => /** @type {HTMLElement} */ (el).dataset.sectionId)
    .filter(Boolean);

  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: String(id), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionIds.join(',') }),
    });
    const data = await response.json();
    const cart = await fetchCart(routes.cart_url);
    deferred.resolve({
      cart: cart ? CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : null,
      detail: {
        items: cart?.items,
        source: 'fuzzle-cart-nudge',
        itemCount: 1,
        sections: data.status ? undefined : data.sections,
        didError: Boolean(data.status),
      },
    });
  } catch (error) {
    console.error(error);
    deferred.reject(error);
    button.disabled = false;
  }
});

/** @param {string} cartUrl */
async function fetchCart(cartUrl) {
  try {
    const response = await fetch(`${cartUrl}.json`, { headers: { Accept: 'application/json' } });
    return await response.json();
  } catch {
    return null;
  }
}
